import { render, staticRenderFns } from "./MessagesZero.vue?vue&type=template&id=816fbece&"
import script from "./MessagesZero.vue?vue&type=script&lang=js&"
export * from "./MessagesZero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports